module.exports = __webpack_public_path__ + "static/img/select-chat.ddc5787.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/select-chat.svg
// module id = HWV+
// module chunks = 31